import {
  AssessmentStudentRow,
  PaginatedResponse,
} from '../types/AssessmentTable.type';
import { apiGet } from './apiClient';

export const getAssessmentStudents = async (
  program: 'SOF' | 'FLYING FISH',
  page: number,
  limit: number,
  search: string,
  level = '',
) => {
  const params = new URLSearchParams({
    program,
    page: String(page),
    limit: String(limit),
    search,
    level,
  });
  return apiGet<PaginatedResponse<AssessmentStudentRow>>(
    `/registration/assessment/list?${params.toString()}`,
  );
};
